import axios from './axiosInstance';

export const getFleetEmissionSummary = async ({ fleetId, startDate, endDate }) => {
  const res = await axios.get(`/fleets/${fleetId}/emissions/summary`, {
    params: {
      start: startDate,
      end: endDate,
    },
  });
  return res;
};

export const getFleetEmissionKPITrends = async ({ fleetId, startDate, endDate }) => {
  const res = await axios.get(`/fleets/${fleetId}/emissions/kpitrend`, {
    params: {
      start: startDate,
      end: endDate,
    },
  });
  return res;
};

export const getFleetEmissionOverview = async ({ fleetId, startDate, endDate }) => {
  const res = await axios.get(`/fleets/${fleetId}/emissions/overviewapi`, {
    params: {
      start: startDate,
      end: endDate,
    },
  });
  return res;
};

export const getFleetFuelConsumptionParams = async ({ fleetId, startDate, endDate }) => {
  const res = await axios.get(`/fleets/${fleetId}/emissions/fuelconsparams`, {
    params: {
      start: startDate,
      end: endDate,
    },
  });
  return res;
};